import { Navigate, Outlet } from "react-router";
import { Skeleton } from "@/components/ui/skeleton";
import { useWorkspace } from "@/lib/session/workspace-context";

/**
 * Wrap the pages that only make sense inside a business. A brand new account has none yet, so it
 * is sent to create one instead of landing on an empty dashboard.
 */
export function WorkspaceGate() {
  const { loading, needsOnboarding } = useWorkspace();

  if (loading) {
    return (
      <div className="space-y-3" aria-busy="true">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }
  if (needsOnboarding) return <Navigate to="/workspaces/new" replace />;
  return <Outlet />;
}
